const tabs = {
  roulette: [],
  popular: [],
  nuevo: [
    'fafnirskey',
    'sevensfruitfiesta',
    'lootnload',
    "hookthecash",
    "eveofgifts",
    "europeanblackjackmultihand"
  ]
};

function getTab(slotName) {
  const trueTab = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab].findIndex(item => item === slotName) === -1 ? acc : [...acc, tab]),
    ['slotMachines'],
  );
  return trueTab;
}

export { getTab };
